import { useRouter } from "next/router";

import { useEffect } from "react";

import useAuthentication from "hooks/useAuthentication";

const useInterfaceSetting = () => {
  const router = useRouter();
  const collection = router.query?.collection as string;

  const { authenticated, account, interfaceSetting, updateInterfaceSetting } =
    useAuthentication();

  useEffect(() => {
    if (router.query?.tab === "widgets") return;

    // if (
    //   collection &&
    //   collection !== interfaceSetting?.nextjsDashboardCollection
    // ) {
    //   updateInterfaceSetting({
    //     nextjsDashboardCollection: collection,
    //   });
    // }

    if (!collection) {
      if (authenticated) {
        router.push(
          {
            pathname: router.pathname,
            query: {
              ...router.query,
              collection: "my-reading-list",
            },
          },
          undefined,
          { shallow: true }
        );
      } else {
        router.push(
          {
            pathname: router.pathname,
            query: { ...router.query, collection: "all-insights" },
          },
          undefined,
          { shallow: true }
        );
      }
    }
  }, [
    account,
    authenticated,
    collection,
    interfaceSetting?.nextjsDashboardCollection,
    router,
    updateInterfaceSetting,
  ]);
};

export default useInterfaceSetting;
